import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  ANY_SPORT_SCOUTING_CENTER_STATS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
  MLB_SCOUTING_CENTER_MATCHES,
  MLB_SCOUTING_CENTER_MATCHES_DAY,
  MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
  MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID_BOX_SCORE,
  MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID_PLAYERS,
} from '@sorare/core/src/constants/__generated__/routes';
import {
  glossary,
  navLabels,
  scoutingCenter,
} from '@sorare/core/src/lib/glossary';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

enum ScoutingCenterTabs {
  STATS = 'STATS',
  WATCHLISTS = 'WATCHLISTS',
  GAMES = 'GAMES',
}

const tabs = [
  {
    tab: ScoutingCenterTabs.STATS,
    label: navLabels.stats,
    to: generateSportPath(ANY_SPORT_SCOUTING_CENTER_STATS, {
      sport: Sport.BASEBALL,
    }),
    matches: [ANY_SPORT_SCOUTING_CENTER_STATS],
  },
  {
    tab: ScoutingCenterTabs.GAMES,
    label: glossary.games,
    to: generatePath(MLB_SCOUTING_CENTER_MATCHES),
    matches: [
      MLB_SCOUTING_CENTER_MATCHES,
      MLB_SCOUTING_CENTER_MATCHES_DAY,
      MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID,
      MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID_BOX_SCORE,
      MLB_SCOUTING_CENTER_MATCHES_DAY_GAMEID_PLAYERS,
    ],
  },
  {
    tab: ScoutingCenterTabs.WATCHLISTS,
    label: scoutingCenter.watchlists,
    to: generateSportPath(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS, {
      sport: Sport.BASEBALL,
    }),
    matches: [ANY_SPORT_SCOUTING_CENTER_WATCHLISTS],
  },
];

const ScoutingCenterLayout = () => {
  return (
    <>
      <PageHeader text={scoutingCenter.scout} disableBackBrowser />
      <ContentWithStickyHeader
        header={
          <TabBar variant="flat" fullWidth ignoreQueryParams>
            {tabs.map(({ to, tab, label, matches }) => (
              <Tab key={tab} to={to} matches={matches}>
                <FormattedMessage {...label} />
              </Tab>
            ))}
          </TabBar>
        }
      >
        <Outlet />
      </ContentWithStickyHeader>
    </>
  );
};

export default ScoutingCenterLayout;
